export const getCoursePageNextStepUrl = (hasNextTask: () => boolean, taskPosition: string): (() => string) => {
  return () => {
    if (hasNextTask()) {
      return `/enrollee/${parseInt(taskPosition, 10) + 1}`
    }
    return `/`
  }
}
